import Text from "../../../../Components/Text";
import React, { useState, useEffect } from "react";
import Form from "../../../../Components/Form";
import NumberInput from "../../../../Components/Form/NumberInput";
import Dropdown from "../../../../Components/Dropdown";
import Offer from "../../../../APIController/Offer";
import { getAllProducts } from "../../../../Model/Products";
import Button from "../../../../Components/Buttons/Button";
import { getWorkspace } from "../../../../Model/Workspace";

const OfferForm = ({ afterAction }) => {
    const { createOffers } = Offer()
    const [workspace, setWorkspace] = useState(null)
    useEffect(() => {
        async function saveWorkspace() {
            const data = await getWorkspace()
            setWorkspace(data)
        }
        saveWorkspace()
    }, [])
    const currency = workspace?.currency

    // Attributes
    const [offerCount, setOfferCount] = useState(1)
    const [offerPrice, setOfferPrice] = useState(0)
    const [products, setProducts] = useState([])
    const [selectedProducts, setSelectedProducts] = useState([{
        id: "",
        count: 1
    }])

    useEffect(() => {
        fetchProductData()
    }, [])

    const fetchProductData = async () => {
        const data = await getAllProducts()
        setProducts(data)
    }

    const handleAddProduct = () => {
        setSelectedProducts([...selectedProducts, { id: "", count: 1 }])
    }

    const handleRemoveProduct = (index) => {
        if (selectedProducts.length > 1) {
            setSelectedProducts(selectedProducts.filter((_, i) => i !== index))
        }
    }

    const handleProductChange = (index, productId) => {
        const newProducts = [...selectedProducts]
        newProducts[index].id = productId
        setSelectedProducts(newProducts)
    }

    const handleProductCountChange = (index, count) => {
        const newProducts = [...selectedProducts]
        newProducts[index].count = parseInt(count)
        setSelectedProducts(newProducts)
    }

    // Baut aus der Auswahl (id + count) die echten OrderProductSnapshot-Objekte,
    // die das Backend erwartet (name, price, mwst, ... werden aus den geladenen
    // Produktdaten nachgeschlagen, nicht mehr nur id/count geschickt)
    const buildSnapshotProducts = () => {
        return selectedProducts.map(sp => {
            const product = products.find(p => p.id === sp.id || p.id === parseInt(sp.id))

            if (!product) {
                return null
            }

            return {
                productId: product.id,
                name: product.name,
                price: product.price,
                buyingPrice: product.buyingPrice ?? null,
                mwst: product.mwst ?? null,
                toGomwst: product.toGomwst ?? null,
                reduceable: product.reduceable ?? false,
                count: sp.count && sp.count > 0 ? sp.count : 1,
                extras: []
            }
        })
    }

    const handleSubmit = (e) => {
        e.preventDefault()

        if (selectedProducts.some(sp => !sp.id)) {
            alert("Bitte wähle für alle Felder ein Produkt aus")
            return
        }

        const snapshotProducts = buildSnapshotProducts()

        if (snapshotProducts.some(sp => sp === null)) {
            alert("Eines der ausgewählten Produkte konnte nicht gefunden werden")
            return
        }

        const offerDTO = {
            offerPrice: offerPrice,
            offerSnapshotProducts: snapshotProducts
        }

        handleAddOffer(offerDTO, offerCount)
    }

    const handleAddOffer = async (offerDTO, count) => {
        await createOffers(count, offerDTO)
        afterAction()
    }

    const getProductOptions = () => {
        if (!products || products.length === 0) {
            return [{ value: "", label: "Keine Produkte verfügbar" }]
        }
        return [
            { value: "", label: "Produkt wählen..." },
            ...products.map(product => ({
                value: product.id,
                label: `${product.name} (${product.price}${currency})`
            }))
        ]
    }

    /* Form  */
    return (
        <Form onSubmitAction={handleSubmit} submitButtonText="Coupons erstellen">
            <Text type="maintitle" classNames={"flex text-center justify-center mb-6"}>
                Coupons erstellen
            </Text>

            <div className="mb-4 space-y-4">
                {/* Anzahl der Gutscheine */}
                <NumberInput
                    attribute={offerCount}
                    id={"offerCount"}
                    label={"Anzahl Coupons"}
                    placeholder={"Anzahl"}
                    action={(e) => setOfferCount(parseInt(e.target.value))}
                />

                {/* Gutschein-Preis */}
                <NumberInput
                    attribute={offerPrice}
                    id={"offerPrice"}
                    label={"Gutschein-Preis"}
                    placeholder={"Preis"}
                    action={(e) => setOfferPrice(parseFloat(e.target.value))}
                />

                {/* Plus Button für Produkte */}
                <div className="flex justify-between items-center mt-6 mb-2">
                    <Text type="itemtext" classNames="font-bold">Produkte im Gutschein</Text>
                    <Button onClickAction={handleAddProduct} buttonColor="bg-green-500 hover:bg-green-600" textClasses="text-white">+ Produkt</Button>
                </div>

                {/* Produkt-Liste */}
                {selectedProducts.map((sp, index) => (
                    <div key={index} className="flex flex-col gap-3 p-4 bg-gray-50 rounded-lg">
                        {/* Produkt Dropdown */}
                        <div className="flex-1">
                            <Dropdown
                                label="Produkt"
                                options={getProductOptions()}
                                value={sp.id}
                                onChange={(value) => handleProductChange(index, value)}
                            />
                        </div>

                        {/* Anzahl */}
                        <div>
                            <Text type="itemtext">Anzahl</Text>
                            <NumberInput
                                attribute={sp.count}
                                id={`productCount-${index}`}
                                placeholder={"Anzahl"}
                                action={(e) => handleProductCountChange(index, e.target.value)}
                            />
                        </div>

                        {/* Löschen Button */}
                        {selectedProducts.length > 1 && (
                            <Button onClickAction={() => handleRemoveProduct(index)} buttonColor="bg-red-500 hover:bg-red-600" textClasses="text-white" tIconName={"x"} />
                        )}
                    </div>
                ))}
            </div>
        </Form>
    )
}

export default OfferForm